import { render, staticRenderFns } from "./HostingOverview.vue?vue&type=template&id=588d96ac&"
import script from "./HostingOverview.vue?vue&type=script&lang=js&"
export * from "./HostingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports